module.exports = __webpack_public_path__ + "img/iconNo8.c02405f3.png";